/* eslint-disable max-lines */
import md5 from "md5";
import GoalType from "@/constants/GoalType";
import TeamMemberStatusType from "@/constants/TeamMemberStatusType";
import GoalTypeFilter from "@/components/Goals/GoalList/GoalTypeFilter";
import orderBy from "lodash/orderBy";
import { sortGoals } from "@/lib/goalUtil";

export default {
	activeGoalCount: state => {
		return state.initialMetadata.goalCounts[ GoalType.ACTIVE ];
	},
	archiveGoalCount: state => {
		return state.initialMetadata.goalCounts[ GoalType.ARCHIVED ];
	},
	availableKeyResultOwners: state => {
		const availableOwners = ( state.selectedGoalTeam.members || [] )
			.filter( member => member.status === TeamMemberStatusType.ACTIVE )
			.map( member => {
				return { value: member.personId, text: ( member.name || member.email ), };
			} );
		return orderBy( availableOwners, [ "test", "asc", ] );
	},
	confidenceLevelMap: state => state.confidenceLevelMap,
	confidenceLevels: state => {
		return Object.keys( state.confidenceLevelMap ).map( value => {
			return { value, text: state.confidenceLevelMap[ value ], };
		} );
	},
	draftGoalCount: state => {
		return state.initialMetadata.goalCounts[ GoalType.DRAFT ];
	},
	duplicateKeyResultErrors: state => state.duplicateKeyResultErrors,
	editingGoalId: state => state.editingGoalId,
	editingKeyResultsMap: state => state.editingKeyResultsMap,
	editingKeyResultsOrder: state => state.editingKeyResultsOrder,
	examinedGoal: state => state.examinedGoal,
	filteredGoals: ( state, getters, rootState, rootGetters ) => {
		let myGoals = state.myGoals;
		if ( state.selectedTeamId ) {
			myGoals = myGoals.filter( goal => goal.teamId === state.selectedTeamId );
		}
		if ( state.selectedGoalType ) {
			const filter = ( goal, ...args ) => {
				return GoalTypeFilter[ state.selectedGoalType ]( goal, ...args );
			};
			const timezone = rootGetters[ "auth/timezone" ];
			myGoals = myGoals.filter( goal => filter( goal, timezone ) );
		}
		return sortGoals( myGoals, state.sortDirection );
	},
	goalTypeMap: state => state.goalTypeMap,
	hasGoalsAvailableToFetch: ( state, getters ) => {
		let hasGoalsToFetch = getters.activeGoalCount > 0;

		if ( state.selectedGoalType === GoalType.DRAFT ) {
			hasGoalsToFetch = getters.draftGoalCount > 0;
		}

		if ( state.selectedGoalType === GoalType.ARCHIVED ) {
			hasGoalsToFetch = getters.archiveGoalCount > 0;
		}
		return hasGoalsToFetch;
	},
	initialMetadata: state => state.initialMetadata,
	initialTeamGoalsMetadata: state => teamId => {
		return state.initialMetadata?.teamSummary?.[ teamId ] || {
			activeGoalCount: 0,
			draftGoalCount: 0,
			archivedGoalCount: 0,
			goalCount: 0,
			teamId,
			defaults: true,
		};
	},
	isGoalDialogOpen: state => state.isGoalDialogOpen,
	isInitialLoadComplete: state => state.isInitialLoadComplete,
	isLoadingGoals: state => state.isLoadingGoals,
	isResortingGoals: state => state.isResortingGoals,
	isSavingGoal: state => state.isSavingGoal,
	isSelectedGoalTeamChanging: state => state.isSelectedGoalTeamChanging,
	keyResultBinaryChoiceMap: state => state.keyResultBinaryChoiceMap,
	keyResultBinaryChoices: state => {
		return Object.keys( state.keyResultBinaryChoiceMap ).map( value => {
			return { value, text: state.keyResultBinaryChoiceMap[ value ], };
		} );
	},
	keyResultFetchErrors: state => state.keyResultFetchErrors,
	keyResultFetchStatusMap: state => state.keyResultFetchStatusMap,
	keyResultMeasurementMap: state => state.keyResultMeasurementMap,
	keyResultMeasurements: state => {
		return Object.keys( state.keyResultMeasurementMap ).map( value => {
			return { value, text: state.keyResultMeasurementMap[ value ], };
		} );
	},
	keyResultsMap: state => {
		return state.keyResultsMap;
	},
	keyResultVisibilityMap: state => state.keyResultVisibilityMap,
	myGoals: state => state.myGoals,
	goalsHash: state => {
		const goalIds = [ ...state.myGoals, ].sort();
		return md5( goalIds );
	},
	noMoreGoalsForType: state => state.noMoreGoalsForType,
	selectedGoalTeam: state => state.selectedGoalTeam,
	selectedGoalType: state => state.selectedGoalType,
	selectedTeamId: state => state.selectedTeamId,
	sortDirection: state => state.sortDirection,
};



// WEBPACK FOOTER //
// ./src/store/modules/goals/getters.js